import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Hero from './components/Hero';
import CategoryGrid from './components/CategoryGrid';
import HotSites from './components/HotSites';
import ArticleSection from './components/ArticleSection';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <CategoryGrid />
        <HotSites />
        <ArticleSection />
      </main>
      <Footer />
      <ScrollToTop />
    </>
  );
}